export let AccordionItemDataAttributes = /*#__PURE__*/function (AccordionItemDataAttributes) {
  /**
   * Indicates the index of the accordion item.
   * @type {number}
   */
  AccordionItemDataAttributes["index"] = "data-index";
  /**
   * Present when the accordion item is disabled.
   */
  AccordionItemDataAttributes["disabled"] = "data-disabled";
  /**
   * Present when the accordion item is open.
   */
  AccordionItemDataAttributes["open"] = "data-open";
  return AccordionItemDataAttributes;
}({});